import React from 'react';
import { Link } from 'react-router-dom';

interface ButtonProps {
  href?: string; // For external or anchor links
  to?: string; // For React Router links
  onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>; // Event handler
  children: React.ReactNode; // Content inside the button
  className?: string; // Additional TailwindCSS or custom styles
}

const Button = ({ href, to, onClick, children, className = '' }: ButtonProps) => {
  const baseClasses =
    'px-6 py-3 bg-primary text-white font-medium rounded-md hover:bg-primary-dark transition';

  if (to) {
    // Render a React Router Link
    return (
      <Link to={to} className={`${baseClasses} ${className}`}>
        {children}
      </Link>
    );
  }

  if (href) {
    // Render an anchor tag
    return (
      <a href={href} onClick={onClick} className={`${baseClasses} ${className}`}>
        {children}
      </a>
    );
  }

  // Render a button element
  return (
    <button type="button" onClick={onClick} className={`${baseClasses} ${className}`}>
      {children}
    </button>
  );
};

export default Button;
